<template>
    <header class="header">
        <div @click="toggleMobileMenu()" class="header__toggle-m">
            <img src="../assets/images/bars.svg">
        </div>
        <div class="container">
            <div class="row">
                <div class="col-8 col-md-6 col-lg-4">
                    <router-link to="/" :title="$t('site_name')">
                        <img class="logo__image" src="../assets/images/logo.png"  :alt="$t('site_name')" :title="$t('site_name')"/>
                    </router-link>
                </div>
                <div class="col-1 col-md-6 col-lg-1 header__col-lang">
                    <div class="header__lang">
                         <TheLanguageSwitcher/>
                    </div>
                </div>
                <div class="col-lg-7 header__col-menu">
                    <ul class="header__menu" @click="closeMobileNav">
                        <li>
                            <router-link :to="$i18nRoute({ name: 'Homepage'})" :title="$t('menu_home')" v-scroll-to="'#section_hero'">
                                {{ $t('menu_home') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="$i18nRoute({ name: 'Homepage'})" :title="$t('menu_aboutus')" v-scroll-to="'#section_about_us'">
                                {{ $t('menu_aboutus') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="$i18nRoute({ name: 'Homepage'})" :title="$t('menu_services')" v-scroll-to="'#section_services'">
                                {{ $t('menu_services') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="$i18nRoute({ name: 'Homepage'})" :title="$t('menu_whyus')" v-scroll-to="'#section_whyus'">
                                {{ $t('menu_whyus') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="$i18nRoute({ name: 'Homepage'})" :title="$t('menu_contact')" v-scroll-to="'#section_contact'">
                                {{ $t('menu_contact') }}
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import TheLanguageSwitcher from '@/components/TheLanguageSwitcher'

export default {
  name: 'app',
  components: {
    TheLanguageSwitcher
  },
  created: function () {
    this.scrollNav()
  },
  methods: {
    toggleMobileMenu () {
      document.querySelector('.header__menu').classList.toggle('open-mobile')
    },
    scrollNav () {
      window.addEventListener('scroll', function () {
        if (window.scrollY >= 80) {
          document.querySelector('.header').classList.add('scroll')
        } else {
          document.querySelector('.header').classList.remove('scroll')
        }
      })
    },
    closeMobileNav () {
      if (window.innerWidth < 1051) {
        document.querySelector('.header__menu').classList.remove('open-mobile')
      }
    }
  }
}
</script>

<style lang="scss">
    @import "../assets/scss/variables.scss";
    .header {
        background-color: $primary;
        position: fixed;
        left: 0;
        right: 0;
        padding: 0;
        z-index: 2;
        @media screen and (min-width: 980px) {
            background-color: transparent;
        }
        &__menu {
            display: none;
            list-style: none;
            margin: 0;
            padding: 0;
            li {
                a {
                    padding: 15px;
                    color: $white;
                    text-decoration: none;
                    font-size: 19px;
                    font-weight: 300;
                    display: block;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    cursor: pointer;
                    @media screen and (min-width: 1051px) {
                        padding: 32px 8px;
                    }
                    @media screen and (min-width: 1224px) {
                        padding: 32px 15px;
                    }
                }
                @media screen and (min-width: 1051px) {
                    display: inline-block;
                }
            }
            @media screen and (min-width: 1051px) {
                text-align: right;
            }
            @media screen and (min-width: 1051px) {
                display: block;
            }
            &.open-mobile {
                @media screen and (max-width: 1050px) {
                    display: block;
                    background: $black;
                    margin: 0px -15px;
                }
            }
        }
        &__col-menu {
            @media screen and (max-width: 1050px) {
                width: 100%;
                flex: none;
                max-width: 100%;
            }
        }
        &__col-lang {
            @media screen and (min-width: 900px) and (max-width: 1050px) {
                flex: 0 0 43%;
                max-width: 43%;
            }
        }
        &__lang {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }
        &__lang-item {
            margin: 0 10px;
            font-size: 18px;
            cursor: pointer;
        }
        &__toggle-m {
            z-index: 2;
            position: fixed;
            right: 15px;
            top: 15px;
            cursor: pointer;
            img {
                height: 35px;
            }
            @media screen and (min-width: 767px) {
                top: 28px;
            }
            @media screen and (min-width: 1051px) {
                display: none;
            }
        }
        &.scroll{
            @media screen and (min-width: 980px) {
                background-color: $primary;
            }
        }
    }
    .logo {
        &__image {
            width: 188px;
            margin: 5px 0;
            float: left;
            @media screen and (min-width: 767px) {
                width: 288px;
            }
        }
    }
</style>






// WEBPACK FOOTER //
// src/components/Header.vue